import React from 'react'
import EditButton from './EditButton';
import DeleteButton from './DeleteButton';
import ProductActionDropdown from './ProductActionDropdown';


const TableAction = ( {onEdit, onDelete, onView, onCreate, productId, showDropdown = false }) => {
  return (
    <div className="action-cell-container">
        <EditButton onEdit={onEdit} />
        <DeleteButton onDelete={onDelete} />
        {showDropdown && (
          <ProductActionDropdown 
            onView={onView} 
            onCreate={onCreate} 
            productId={productId}
          />
        )}
    </div>
  )
}

export default TableAction